import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import MyPlans from "./MyPlans";
import MyCoupons from "./MyCoupons";

const CustomerPlansAndCoupons = () => {
  const [value, setValue] = useState("plans");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <TabContext value={value}>
          <Box>
            <Tabs onChange={handleChange} aria-label="lab API tabs example">
              <Tab
                sx={
                  value === "plans"
                    ? {
                        backgroundColor: "#2D256C",
                        width: "130px",
                        borderRadius: "5px 0px 0px 5px",
                        color: "white",
                        minHeight: "40px",
                        fontSize: "12px",
                        fontWeight: 600,
                      }
                    : {
                        backgroundColor: "white",
                        width: "130px",
                        border: "0.5px solid #D9D9D9",
                        borderRadius: "5px 0px 0px 5px",
                        color: "black",
                        minHeight: "40px",
                        fontSize: "12px",
                        fontWeight: 600,
                      }
                }
                label="My Plans"
                value="plans"
              />
              <Tab
                sx={
                  value === "coupons"
                  ? {
                    backgroundColor: "#2D256C",
                    width: "130px",
                    borderRadius: "0px 5px 5px 0px",
                    color: "white",
                    minHeight:"40px",
                    fontSize:"12px",
                    fontWeight:600
                  }
                : {
                    backgroundColor: "white",
                    width: "130px",
                    border: "0.5px solid #D9D9D9",
                    borderRadius: "0px 5px 5px 0px",
                    color: "black",
                    minHeight:"40px",
                    fontSize:"12px",
                    fontWeight:600
                  }
                }
                label="My Coupons"
                value="coupons"
              />
              
            </Tabs>
          </Box>
          <TabPanel value="plans">
            <MyPlans/>
          </TabPanel>
          <TabPanel value="coupons">
            <MyCoupons/>
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};

export default CustomerPlansAndCoupons;
